module.exports = __webpack_public_path__ + "img/content_5.8a7e4590.png";